import React, { useState } from 'react';
import {
    Row,
    Col,
    Form,
    Button,
    Table,
  } from "react-bootstrap";
import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';


import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// css
import './LandingPage.css'

const LandingPage = () => {


    const [clientName, setClientName] = useState('');
    const [clientId, setClientId] = useState('');
    const [hasSearched, setHasSearched] = useState(false);

    const formatTimestamp = (timestamp: string) => {
            console.log('Original timestamp:', timestamp);
            // Parse the ISO timestamp and convert to local time
            const localTime = dayjs(timestamp).local();
            console.log('Local time:', localTime.format());
            console.log('Current timezone:', dayjs.tz.guess());
            console.log('Current local time:', dayjs().format());
            
            return localTime.format('MM/DD/YYYY hh:mm:ss A');
        };

    const clientsColumnDef: ColDef[] = [

        { headerName: 'ClientName', field: 'ClientName', flex: 1 },
        { headerName: 'ClientId', field: 'ClientId', flex: 1 },
        { headerName: 'Status', field: 'Status', flex: 2 },
       
        ]

    const defaultColDef: ColDef = {
        sortable: true,
        filter: true,
        resizable: true,
    };



    const handleSearch = () => {
        // alert(`Searching for Client Name: ${clientName} or Client ID: ${clientId}`);
        setHasSearched(true); // trigger layout change
        // Add your search logic here (e.g., API call)
      };

    const onFirstDataRendered = (params: any) => {
        params.api.sizeColumnsToFit();
    };

  return (
    <>
        <div className={`container-fluid ${hasSearched ? 'top-layout' : 'form-wrapper'}`}>
      {!hasSearched ? (
        <>
          <Row className="w-100 justify-content-center">
            <Col md={3} className="text-center">
              <Form.Group>
                <Form.Label>Client Name</Form.Label>
                <Form.Control
                  type="text"
                  value={clientName}
                  onChange={(e) => setClientName(e.target.value)}
                  className="landingFormControl"
                />
              </Form.Group>
            </Col>
            <Col md={2} className="text-center d-flex align-items-center justify-content-center">
              <h2>OR</h2>
            </Col>
            <Col md={3} className="text-center">
              <Form.Group>
                <Form.Label>Client ID</Form.Label>
                <Form.Control
                  type="text"
                  value={clientId}
                  onChange={(e) => setClientId(e.target.value)}
                  className="landingFormControl"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3 justify-content-center">
            <Button className='customButton' onClick={handleSearch}>
              Search Client
            </Button>
          </Row>
        </>
      ) : (
        <Row className="align-items-center mt-2">
          <Col md={3}>
            <Form.Control
              type="text"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              placeholder="Client Name"
            />
          </Col>
          <Col md={3}>
            <Form.Control
              type="text"
              value={clientId}
              onChange={(e) => setClientId(e.target.value)}
              placeholder="Client ID"
            />
          </Col>
          <Col md={3}>
            <Button className='customButton' onClick={handleSearch}>
              Search Client
            </Button>
          </Col>
        </Row>
      )}
      
    </div>



    </>
  )
}

export default LandingPage